import React from 'react';
import '../../styles/pages.css';

export default function Campaigns() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Campaigns</h1>
        <p>Manage your SMS campaigns</p>
      </div>
      <div className="page-section">
        <button className="btn-primary">Create Campaign</button>
        <p className="text-muted" style={{ marginTop: '2rem' }}>Campaigns management coming soon.</p>
      </div>
    </div>
  );
}
